import { Idiomorph } from "idiomorph/dist/idiomorph.esm.js"

export const morphElement = (existingElement, newElement) => {
  Idiomorph.morph(existingElement, newElement)
}
